const regions = [
    {
        'uuid': '1',
        'code': 'north',
        'name': '北區',
        'counties': [
            '花蓮縣',
            '宜蘭縣',
            '苗栗縣',
            '新竹縣',
            '臺北市',
            '新北市',
            '基隆市',
            '桃園市',
        ],
    },
    {
        'uuid': '2',
        'code': 'central',
        'name': '中區',
        'counties': [
            '臺中市',
            '彰化縣',
            '南投縣',
        ],
    },
    {
        'uuid': '3',
        'code': 'yunjia',
        'name': '雲嘉',
        'counties': [
            '雲林縣',
            '嘉義市',
        ],
    },
    {
        'uuid': '4',
        'code': 'south',
        'name': '南區',
        'counties': [
            '高雄市',
            '臺南市',
            '屏東縣',
            '臺東縣',
        ],
    },
    {
        'uuid': '5',
        'code': 'hq',
        'name': '總部',
        'headquarters': true,
    },
]

export default regions;